import { Controller } from '@hotwired/stimulus'

/**
 * GET-Filter für Kunden-Anfragen liefern keinen URL-Hash mit; der Tabs-Controller
 * bleibt sonst auf „Profil“. Bei requisitions_q / requisitions_page den Anfragen-Tab aktivieren.
 */
export default class extends Controller {
  connect() {
    const search = window.location.search
    if (!search || search.length <= 1) return

    const params = new URLSearchParams(search)
    let hasReqParams = false
    for (const key of params.keys()) {
      if (key === 'requisitions_page' || key.startsWith('requisitions_q')) {
        hasReqParams = true
        break
      }
    }
    if (!hasReqParams) return

    if (window.location.hash === '#customer_tab_requisitions') return

    const tabLink = document.querySelector('a[href="#customer_tab_requisitions"][data-customer-detail-tabs-target="tab"]')
    if (!tabLink) return

    queueMicrotask(() => {
      tabLink.click()
      if (typeof history.replaceState === 'function') {
        const next = `${window.location.pathname}${window.location.search}#customer_tab_requisitions`
        history.replaceState(null, '', next)
      }
    })
  }
}
